import type { WarrantyHistory } from '@econtractor/types';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import WarrantyHistoryItem from './WarrantyHistoryItem';

interface TabHistoryProps {
    rows: WarrantyHistory[];
}

const TabHistory = ({ rows }: TabHistoryProps) => {
    const { t } = useTranslation('Warranties');

    if (!rows.length) {
        return (
            <div className="text-muted py-3 text-center">
                <SolarIcon name="clock-history" className="me-2" />
                {t('empty')}
            </div>
        );
    }

    return (
        <ul className="task-history-timeline list-unstyled mb-3">
            {rows.map((row) => (
                <WarrantyHistoryItem key={row.ID} row={row} />
            ))}
        </ul>
    );
};

export default TabHistory;
